export const ADD_ALL_GROUPS = "ADD_ALL_GROUPS";
export const REMOVE_ALL_GROUPS = "REMOVE_ALL_GROUPS";
export const EDIT_GROUP_BY_INDEX = "EDIT_GROUP_BY_INDEX";
export const REMOVE_GROUP_BY_INDEX = "REMOVE_GROUP_BY_INDEX";
